import React from 'react'
import clsx from 'clsx'
import { sanitizeAttachmentUrl } from '../messaging-utils'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    overflow: 'hidden',
    boxShadow: 'none',
  },
  media: {
    flexShrink: 0,
    width: 112,
    minHeight: 120,
    backgroundColor: '#ebf0f2',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#172024',
    '& .MuiSvgIcon-root': {
      fontSize: 32,
    },
  },
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: 4,
    minWidth: 0,
    padding: '12px 16px',
  },
  title: {
    color: '#172024',
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.25,
  },
  meta: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.25,
  },
  cta: {
    marginTop: 'auto',
    paddingTop: 8,
    color: '#0053ff',
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.25,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
})

const BookingAttachmentCard = ({
  bookingUrl,
  className,
  ctaText = 'Click to Register',
  detailLine,
  fallbackIcon = null,
  imageUrl,
  locationName,
  title,
  type,
}) => {
  const classes = useStyles()
  const sanitizedUrl = sanitizeAttachmentUrl(bookingUrl)
  const safeImageUrl = sanitizeAttachmentUrl(imageUrl)

  return (
    <div
      className={clsx(
        'messaging-booking-attachment-card',
        'str-chat__message-attachment-card',
        type && `str-chat__message-attachment-card--${type}`,
        classes.root,
        className,
      )}
    >
      <div
        className={classes.media}
        style={
          safeImageUrl
            ? { backgroundImage: `url("${safeImageUrl}")` }
            : undefined
        }
      >
        {!safeImageUrl && fallbackIcon}
      </div>
      <div className={classes.content}>
        <Typography className={classes.title} component="p" variant="body2">
          {title}
        </Typography>
        {locationName && (
          <Typography className={classes.meta} component="p" variant="body2">
            {locationName}
          </Typography>
        )}
        {detailLine && (
          <Typography className={classes.meta} component="p" variant="body2">
            {detailLine}
          </Typography>
        )}
        {sanitizedUrl && (
          <a
            className={clsx(
              classes.cta,
              'str-chat__message-attachment-card--title',
              'str-chat__message-attachment-card--url',
            )}
            href={sanitizedUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            {ctaText}
          </a>
        )}
      </div>
    </div>
  )
}

export default BookingAttachmentCard
